import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'FETCH_FILES',
  'FETCH_PROJECT_FILES',
  'FETCH_FILES_ERROR',
  'DELETE_FILE',
  'DELETE_FILE_SUCCESS',
  'FETCH_FILE_DOWNLOAD_URL',
  'GET_FILE',
  'CREATE_FILE',
  'UPLOAD_FILE',
  'RENAME_FILE',
]);

const actions = createActionTypes(['SET_ACTIVE_FILES_PATH']);

export default {
  ...asyncActions,
  ...actions,
};
